import { render, staticRenderFns } from "./OptimizeAssetLocationButton.vue?vue&type=template&id=68d8ca6b&scoped=true&"
import script from "./OptimizeAssetLocationButton.vue?vue&type=script&lang=js&"
export * from "./OptimizeAssetLocationButton.vue?vue&type=script&lang=js&"
import style0 from "./OptimizeAssetLocationButton.vue?vue&type=style&index=0&id=68d8ca6b&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68d8ca6b",
  null
  
)

export default component.exports